export class ProdutoDesconto {
  public desconto_concedido: number;
  public descritivo_desconto: string;
  public preco_base: number;

  constructor() { }
}
